import { apiInstance1 } from '../store/axios';

function urlWebSocket() {
    try {
        const base = apiInstance1.defaults.baseURL || 'http://localhost:3802/api/v1';
        const url = new URL(base)
        const protocolo = url.protocol === 'https:' ? 'wss:' : 'ws:'
        return `${protocolo}//${url.host}`
    } catch (error) {
        return 'ws://localhost:3802'
    }
}

export default {
    install(app) {
        // Evitar múltiples conexiones
        if (app.config.globalProperties.$ws) {
            return;
        }

        // Misma base que axios.js (local o producción)
        const ws = new WebSocket(urlWebSocket());

        // Manejar la apertura de la conexión
        ws.onopen = () => {
            console.log('Conectado al servidor WebSocket');
        };


        // Manejar mensajes recibidos del servidor
        ws.onmessage = (event) => {
            try {
                const message = JSON.parse(event.data);

                if (message.type === 'new_insert') {
                    app.config.globalProperties.$eventBus.emit('new_insert', message.data);
                } else if (message.type === 'emitirAlerta') {
                    app.config.globalProperties.$eventBus.emit('emitirAlerta', message.data);
                }
            } catch (error) {
                console.error('Error al parsear el mensaje WebSocket:', error);
            }
        };

        // Manejar el cierre de la conexión
        ws.onclose = () => {
            console.log('Conexión WebSocket cerrada');
            app.config.globalProperties.$ws = null;

            setTimeout(() => {
                console.log('Intentando reconectar...');
                this.install(app);
            }, 5000);
        };

        // Manejar errores
        ws.onerror = (error) => {
            console.error('Error en la conexión WebSocket:', error);
            app.config.globalProperties.$ws = null;
        };

        app.config.globalProperties.$ws = ws;

        app.config.globalProperties.$sendWebSocketMessage = (message) => {
            if (ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify(message));
            } else {
                console.error('WebSocket no está conectado');
            }
        };
    }
};
